// Picks the next action to process: the head of whichever planet's queue
// currently has the smallest planet-local time. Deactivated actions are
// still returned (so the caller can echo them into the timeline) but are
// never preferred over an active one at an earlier time than the current
// best candidate — matches legacy SmartActionChooser exactly.
export const SmartActionChooser = (state, buildOrder) => {
  let index;
  let action;
  let time = 0;

  for (const planetId of Object.keys(state.planets)) {
    if (!buildOrder[planetId] || buildOrder[planetId].length === 0) continue;

    const currIndex = state.planets[planetId].index;
    const currAction = buildOrder[planetId][0];

    if (currAction.deactivated === true) {
      if (index === undefined || action === undefined) {
        index = currIndex;
        action = currAction;
        time = state.planets[planetId].time;
      }
      if (state.planets[planetId].time < time) {
        index = currIndex;
        action = currAction;
        time = state.planets[planetId].time;
      }
      continue;
    }

    if (index === undefined || action === undefined) {
      index = currIndex;
      action = currAction;
      time = state.planets[planetId].time;
    }
    if (state.planets[planetId].time < time) {
      index = currIndex;
      action = currAction;
      time = state.planets[planetId].time;
    }
  }

  if (index !== undefined && action !== undefined) {
    state.planets[action.payload.planetId].index++;
    buildOrder[action.payload.planetId].shift();
  }

  return [index, action];
};

// Inserts an incoming transport into the target planet's fleetActions,
// keeping the list sorted by remaining duration.
export const addFleetAction = (state, sourceTime, target, action) => {
  if (state.planets[target] === undefined) return;
  const settings = action.payload.settings;
  const targetTime = state.planets[target].time;
  const duration = sourceTime - targetTime + settings.flight_time;
  if (duration < 0) {
    console.log('Flight too late, yo');
    return;
  }
  settings.flight_time = duration;
  let i = 0;
  while (state.planets[target].fleetActions.length > i && state.planets[target].fleetActions[i].duration < duration) {
    i++;
  }
  state.planets[target].fleetActions.splice(i, 0, action);
};
